<template>
    <!-- 熟练度总览（2026-09-28）：随时查看——采集三线全员熟练度 + 称号系熟练度 -->
    <el-dialog class="detailwrap" custom-class="mastery-dialog" :visible.sync="masteryPanelVisible" :before-close="mastery_panel_close"
               v-loading="loading" append-to-body
               element-loading-background="rgba(0, 0, 0, 0.1)"
               element-loading-text="加载中" element-loading-spinner="el-icon-loading">
        <div class="detailbg masteryBg">
            <center><font color="ff0000" class="title">熟练度总览</font></center>
            <hr color="000000">

            <div class="secTitle">采集熟练度（全员开放 · 上限 = min(175, 等级×5) = {{cap}}）</div>
            <div v-if="gatherLines.length">
                <div v-for="line in gatherLines" v-bind:key="line.code" class="masteryRow">
                    <span class="mname">{{line.name}}</span>
                    <span class="mval">{{line.mastery}} / {{line.cap}}</span>
                    <div class="mbar">
                        <div class="mfill" :style="{width: barPercent(line.mastery, line.cap)}"></div>
                    </div>
                </div>
                <div class="mtip">熟练度越高，出好东西的概率越高、解锁的鱼种/矿种越多；称号持有者产出时还有 50% 概率额外+1 份（馈赠）。</div>
            </div>
            <div v-else class="empty">还没有采集熟练度，去砍树 / 钓鱼 / 挖矿累积吧。</div>

            <div class="secTitle mt20">称号熟练度（随称号评定与日常玩法累积）</div>
            <div v-if="titleMasteries.length">
                <div v-for="ability in titleMasteries" v-bind:key="ability.id" class="masteryRow">
                    <span class="mname">{{ability.titleName}} · {{ability.abilityName}}<em v-if="ability.status == '1'">（使用中）</em></span>
                    <span class="mval">{{ability.mastery}} / {{limitOf(ability)}}<em v-if="levelCapBinds(ability)">（等级上限：{{ability.masteryLimit}} 需 {{Math.ceil((ability.masteryLimit || 175) / 5)}} 级）</em></span>
                    <div class="mbar">
                        <div class="mfill" :style="{width: barPercent(ability.mastery, limitOf(ability))}"></div>
                    </div>
                </div>
            </div>
            <div v-else class="empty">还没有称号熟练度记录，先在「称号评定」处评定一个称号吧。</div>
        </div>
    </el-dialog>
</template>

<script>
import {getRequest} from '../../utils/api'
import {effectiveMasteryLimit} from '../../utils/mastery'

export default {
  name: 'masteryPanel',
  props: {
    masteryPanelVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      level: 0,
      cap: 175,
      gatherLines: [],
      titleMasteries: []
    }
  },
  mounted() {
    this.loadOverview();
  },
  methods: {
    loadOverview() {
      this.loading = true;
      getRequest('/user/title/masteryOverview', {}).then(resp => {
        this.loading = false;
        if (resp.data && resp.data.success) {
          var data = resp.data.data || {};
          this.level = data.level || 0;
          this.cap = data.cap || 175;
          this.gatherLines = data.gatherLines || [];
          this.titleMasteries = data.titleMasteries || [];
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    limitOf(ability) {
      return effectiveMasteryLimit(ability.masteryLimit, this.level);
    },
    // 等级轴封顶时（等级×5 < 配置上限）给出提示，与称号处「我的称号」同口径
    levelCapBinds(ability) {
      var limit = ability.masteryLimit || 175;
      return this.level > 0 && this.level * 5 < limit;
    },
    barPercent(mastery, limit) {
      var max = limit || 1;
      return Math.min(100, Math.round((mastery || 0) / max * 100)) + '%';
    },
    mastery_panel_close() {
      this.$emit('mastery_panel_close');
    }
  }
}
</script>

<style scoped>
.masteryBg { min-height: 200px; min-width: 400px; text-align: left; }
.secTitle { font-weight: bold; margin: 8px 0 6px 4px; color: #333; }
.mt20 { margin-top: 16px; }
.masteryRow { margin: 6px 8px; }
.mname { display: inline-block; min-width: 46%; font-size: 13px; }
.mname em { color: #6a9955; font-style: normal; font-size: 12px; }
.mval { float: right; font-size: 13px; color: #555; }
.mval em { color: #c08a1e; font-style: normal; font-size: 11px; }
.mbar { clear: both; height: 10px; margin-top: 3px; background: #e6e6e6; border-radius: 5px; overflow: hidden; }
.mfill { height: 100%; background: linear-gradient(90deg, #7fb069, #4e9a2f); border-radius: 5px; }
.mtip { margin: 8px 8px 0; font-size: 12px; color: #888; }
.empty { margin: 10px 8px; font-size: 13px; color: #999; }
</style>

<style>
/* 桌面端：弹窗限高，滚动条收进弹窗内部（移动端由 App.vue 全局适配已覆盖） */
@media (min-width: 769px) {
  .mastery-dialog.el-dialog {
    width: 640px !important;
    max-height: 84vh;
    margin-top: 8vh !important;
    display: flex;
    flex-direction: column;
  }
  .mastery-dialog .el-dialog__header { flex-shrink: 0; }
  .mastery-dialog .el-dialog__body { flex: 1; min-height: 0; overflow-y: auto; }
}
/* 移动端：默认 50% 宽窄于内容 400px 最小宽会溢出——放宽弹窗、取消内容最小宽、体内容内滚 */
@media (max-width: 768px) {
  .mastery-dialog.el-dialog { width: 94% !important; margin-top: 5vh !important; }
  .mastery-dialog .masteryBg { min-width: 0; }
  .mastery-dialog .el-dialog__body { overflow-y: auto; max-height: 76vh; }
}
</style>
